import React from "react"; // , { useState }
import AlignerServiceImage from "./../assets/aligners_service.png";

import {
  //   DESCRIPTION_COLOR,
  PRIMARY_COLOR,
  TERTIARY_COLOR,
} from "../constants/theme";

const Service = () => {
  return (
    <div className="p-0" style={{ opacity: 0.5 }}>
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{
          // border: `1px solid ${active ? PRIMARY_COLOR : TERTIARY_COLOR}`,
          border: `1px solid ${PRIMARY_COLOR}`,
          width: "100%",
          padding: "7px 7px 3px 7px",
          borderRadius: "16px",
          // backgroundColor: active ? TERTIARY_COLOR : "unset",
          backgroundColor: TERTIARY_COLOR,
          gap: "9px",
        }}
      >
        <div
          className=""
          style={{
            width: "70px",
          }}
        >
          <img
            className="w-100"
            src={AlignerServiceImage}
            alt="aligner service"
            style={{
              maxWidth: "100%",
            }}
          />
        </div>

        <div
          className="text-center"
          style={{
            fontSize: "14.5px",
            color: "rgb(203, 108, 230)",
            // fontWeight: active ? "600" : "400",
            fontWeight: "600",
            lineHeight: "1.5",
            // minHeight: '60px'
          }}
        >
          Aligners
        </div>
      </div>
    </div>
  );
};

export default Service;
